function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import withSocialCard from './SocialCard';
import { PostBody, MerchantInfo, AdminDate } from './SocialCardStyles';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import lazySizes from 'lazysizes';

var SpecialPost = function (_React$Component) {
  _inherits(SpecialPost, _React$Component);

  function SpecialPost() {
    _classCallCheck(this, SpecialPost);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SpecialPost.prototype.render = function render() {
    var _props = this.props,
        entities = _props.entities,
        profile = _props.profile,
        post = _props.post,
        admin = _props.admin,
        merchant = _props.merchant,
        schedule = _props.schedule;


    if (!merchant) return null;

    var days = schedule.get('days');
    var hours = schedule.get('hours');
    var allDay = hours.count() === 1 && hours.first().get('startTime') === hours.first().get('endTime');
    var daily = days.count() === 7;
    var repeating = schedule.get('start_date') !== schedule.get('end_date');
    var dayFrequency = daily ? 'Daily' : !daily && repeating ? 'Every ' + days.join(', ') : moment(schedule.get('start_date')).format('dddd, MMM Do');

    return React.createElement(
      'div',
      null,
      React.createElement(
        'header',
        { className: 'mb-1' },
        React.createElement(
          PostBody,
          null,
          post.body
        )
      ),
      merchant && React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'font-size-09 mb-1' },
          React.createElement('i', { className: 'fa fa-clock-o mr-1' }),
          dayFrequency,
          ',',
          ' ',
          allDay ? 'All Day' : hours.toJS().map(function (h, i) {
            return React.createElement(
              'span',
              { key: i },
              React.createElement(
                'span',
                { className: 'text-nowrap' },
                moment('1970-01-01 ' + h.startTime).format('h:mm A'),
                ' -',
                ' ',
                moment('1970-01-01 ' + h.endTime).format('h:mm A')
              ),
              i + 1 < hours.count() && ', '
            );
          })
        ),
        React.createElement(MerchantInfo, { profile: profile, merchant: merchant })
      )
    );
  };

  return SpecialPost;
}(React.Component);

SpecialPost.propTypes = process.env.NODE_ENV !== "production" ? {
  post: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  admin: PropTypes.bool
} : {};

export var SpecialPostCard = withSocialCard(SpecialPost);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/social/SpecialPostCard.js
// module id = 729
// module chunks = 4